@if(neighborhoodService.currentNeighborhood) {
  <div class="container-fluid pt-4">
    <div class="row">

      @if(authService.currentUser?.profile === 'sudo') {

        <div class="col-12 text-secondary mb-1">
          <small><b>
            Pases QR
          </b></small>
        </div>

        <div class="col-12 bg-white px-3 rounded mb-4 py-3">
          <div class="row">

            <div class="col-12 col-md-6 mb-3">
              <div class="row">
                <div class="col d-flex align-items-center">
                  Generar código corto para visitas
                </div>
                <div class="col-auto text-end d-flex align-items-center justify-content-end">
                  <p-inputSwitch
                    [(ngModel)]="this.neighborhoodService.currentNeighborhood!.visitsShowShortCode"
                    (onChange)="update()"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
              <div class="row">
                <div class="col d-flex align-items-center">
                  Generar código corto para proveedores
                </div>
                <div class="col-auto text-end d-flex align-items-center justify-content-end">
                  <p-inputSwitch
                    [(ngModel)]="this.neighborhoodService.currentNeighborhood!.visitsShowShortCodeSuppliers"
                    (onChange)="update()"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col d-flex align-items-center">
                  Generar pases recurrentes
                </div>
                <div class="col-auto text-end d-flex align-items-center justify-content-end">
                  <p-inputSwitch
                    [(ngModel)]="this.neighborhoodService.currentNeighborhood!.canCreatePermanentPasses"
                    (onChange)="update()"></p-inputSwitch>
                </div>
              </div>
            </div>

          </div>
        </div>

      }

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Pruebas de accesos
        </b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4 py-3">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-8 d-flex align-items-center">
                Requiere de subir pruebas de accesos
              </div>
              <div class="col-4 text-end d-flex align-items-center justify-content-end">
                <p-inputSwitch
                  [(ngModel)]="this.neighborhoodService.currentNeighborhood!.proofsRequired"
                  (onChange)="update()"></p-inputSwitch>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if(this.neighborhoodService.currentNeighborhood!.proofsRequired) {

        <div class="col-12 text-secondary mb-2">
          <small><b>
            Configuración de pruebas de acceso
          </b></small>
        </div>

        @for(visitType of this.neighborhoodService.currentNeighborhood!.visitTypes; track $index) {

          <div class="col-12 text-secondary mb-1 fw-200">
            <div class="row">
              <div class="col-md-6 d-flex align-items-center">
                <small><b>
                  {{ visitType.description }}
                </b></small>
              </div>

              <div class="col text-end">
                Estatus
              </div>

              @if(this.neighborhoodService.currentNeighborhood!.aiModuleVisits) {

                <div class="col text-end">
                  Procesar con IA
                </div>
                
              }
              
            </div>

          </div>

          <div class="col-12 bg-white px-3 rounded mb-4 py-3">
            <div class="row">

              @for(proofType of visitType.proofTypes; track $index) {

                <div class="col-6 d-flex align-items-center my-1">
                  {{ proofType.description }}
                </div>

                <div class="col text-end d-flex align-items-center justify-content-end my-1">
                  <p-inputSwitch
                    [(ngModel)]="proofType.status"
                    (onChange)="setProofRequired(
                        visitType.visitTypeId, 
                        proofType.proofTypeId, 
                        proofType.status, 
                        proofType.processWithAi
                      )">
                  </p-inputSwitch>
                </div>

                @if(this.neighborhoodService.currentNeighborhood!.aiModuleVisits) {
                  <div class="col text-end d-flex align-items-center justify-content-end my-1">
                    <p-inputSwitch
                      [disabled]="!proofType.status"
                      [(ngModel)]="proofType.processWithAi"
                      (onChange)="setProofRequired(
                          visitType.visitTypeId, 
                          proofType.proofTypeId, 
                          proofType.status, 
                          proofType.processWithAi
                        )">
                    </p-inputSwitch>
                  </div>
                }

              }

            </div>
          </div>

        }

      }

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Campos requeridos para visitas vehiculares y proveedores
        </b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4 pt-3">
        <div class="row">

          <div class="col-12 col-md-6 mb-3">
            <div class="row">
              <div class="col-8 d-flex align-items-center">
                Placas
              </div>
              <div class="col-4 text-end d-flex align-items-center justify-content-end">
                <p-inputSwitch
                  [(ngModel)]="this.neighborhoodService.currentNeighborhood!.platesRequired"
                  (onChange)="update()"></p-inputSwitch>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3">
            <div class="row">
              <div class="col-8 d-flex align-items-center">
                Marca
              </div>
              <div class="col-4 text-end d-flex align-items-center justify-content-end">
                <p-inputSwitch
                  [(ngModel)]="this.neighborhoodService.currentNeighborhood!.brandRequired"
                  (onChange)="update()"></p-inputSwitch>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3">
            <div class="row">
              <div class="col-8 d-flex align-items-center">
                Modelo
              </div>
              <div class="col-4 text-end d-flex align-items-center justify-content-end">
                <p-inputSwitch
                  [(ngModel)]="this.neighborhoodService.currentNeighborhood!.modelRequired"
                  (onChange)="update()"></p-inputSwitch>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3">
            <div class="row">
              <div class="col-8 d-flex align-items-center">
                Color
              </div>
              <div class="col-4 text-end d-flex align-items-center justify-content-end">
                <p-inputSwitch
                  [(ngModel)]="this.neighborhoodService.currentNeighborhood!.colorRequired"
                  (onChange)="update()"></p-inputSwitch>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="col-12 text-secondary mb-1">
        <small><b>
          Configuración de pases
        </b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4 py-3">
        <div class="row">

          <div class="col-12 col-md-6 mb-3">
            <label class="form-label">
              Duración máxima de pases
            </label>
            <input
              type="number"
              class="form-control"
              (keyup.enter)="update()"
              [(ngModel)]="this.neighborhoodService.currentNeighborhood!.passDuration"
              placeholder="Duración máxima de pases (días)">
          </div>

          <div class="col-12">
            <button
              class="btn btn-success w-100 d-flex align-items-center justify-content-center"
              (click)="update()">
              <i class="material-icons me-2">save</i>
              Guardar
            </button>
          </div>

        </div>
      </div>

    </div>
  </div>
}
